<style scoped>
@media (max-width: 992px) {
  .contributor-row {
    text-align: center;
  }

  .contributor-actions {
    text-align: center !important;
    padding-right: 0;
    padding-left: 0;
  }
}

.contributor-row {
  min-height: 80px;
  align-items: center;
  padding: 9px 0 0 0;
  margin: 2px;
}

.contributor-data {
  padding-left: 0;
  margin-left: 0;
}

.picture-box {
  min-width: 70px;
  margin-right: 0;
}

.contributor-name {
  font-weight: bold;
}

.contributor-email {
  font-weight: lighter;
  color: grey;
}

.contributor-actions {
  text-align: center;
  padding-right: 2px;
}

.contributor-row >>> svg {
  cursor: pointer;
}

.trash-col {
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

.trash-icon {
  cursor: pointer;
}

.btn-change-role, .btn-confirm-delete {
  width: 150px !important;
}

.btn-change-role {
  background-color: white;
  border-color: grey;
  color: black;
}

.invite-role {
  font-weight: bold;
}
.invite-status {
  margin: 10px auto;
}
.invite-status > span {
  padding: 6px;
  margin-top: 10px;
  border-radius: 0.25rem;
}
.invite-status-rejected {
  border: 1px solid lightsalmon;
  color: lightsalmon;
}
.invite-status-active {
  border: 1px solid lightseagreen;
  color: lightseagreen;
}
.invite-status-suspended {
  border: 1px solid lightcoral;
  color: lightcoral;
}
.invite-status-pending {
  border: 1px solid lightslategray;
  color: lightslategray;
}
.invite-status-disconnected {
  border: 1px solid chocolate;
  color: chocolate;
}
.col-status {
  padding-top: 10px;
}

.contributor-primary > span {
  padding: 0.1rem 0.5rem;
  color: white;
  background-color: #5252e1;
  border: 1px solid #5252e1;
  border-radius: 0.25rem;
}

.contributor-primary-button > button {
  padding: 0.2rem 1rem;
  color: black;
  background-color: white;
  line-height: 1;
}

</style>
<template>
  <b-row class="contributor-row">
    <b-col lg="5">
      <b-row>
        <b-col col-1 lg="3">
          <div>
            <b-img
              width="63px"
              :src="profilePicture"
            />
          </div>
        </b-col>
        <b-col col-1>
          <div class="contributor-name">
            {{ contributor.name || '-' }}
          </div>
          <div class="contributor-email">
            {{ email || '-' }}
          </div>
          <div class="contributor-primary" v-if="contributor.is_primary_poc">
            <span>Primary Contact</span>
          </div>
          <div v-else class="contributor-primary-button">
            <b-button @click="updatePrimaryContact">Mark as Primary</b-button>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col lg="7" class="contributor-actions">
      <b-row>
        <b-col lg="4" class="col-status">
          <b-col md="12" v-if="contributor.role">
            <span class="invite-role">
              {{ contributor.role | capitalize }}
            </span>
          </b-col>
          <b-col class="invite-status" md="12" v-if="contributor.status">
            <span :class="statusClass">
              {{ contributor.status | capitalize }}
            </span>
          </b-col>
        </b-col>
        <b-col lg="6" align-self="center">
          <b-button
            class="btn-anchor"
            @click="$emit('invite')"
            v-if="noValidRole"
          >
            {{buttonLabel}}
          </b-button>
          <b-button
            v-else
            class="btn-change-role"
            @click="$emit('edit-role')"
          >
            Change Role
          </b-button>
        </b-col>
        <b-col lg="8" class="d-lg-none mt-2" >
          <b-button
            icon="trash"
            color="#6c757d"
            class="btn-confirm-delete"
            @click="confirmDelete"
          >
            Delete
          </b-button>
        </b-col>
        <b-col lg="2" class="trash-col d-none d-lg-block" align-self="center">
          <font-awesome-icon
            icon="trash"
            color="#6c757d"
            class="trash-icon"
            @click="confirmDelete"
          />
        </b-col>
      </b-row>
    </b-col>
    <contributor-delete-modal
      ref="contributorDeleteModal"
      @delete="deleteContributor"
      @remove-role="removeContributorRole"
    />
  </b-row>
</template>
<script>

import ContributorDeleteModal from '@/components/settings/tabs/team_members/ContributorDeleteModal';

export default {
  components: {
    ContributorDeleteModal,
  },
  props: {
    contributor: Object,
    contributor_list_size: Number,
    lastPocUpdate: String,
    profilePicture: {
      type: String,
      default: './static/profile/profile.svg',
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    noValidRole() {
      return this.contributor.status !== 'active';
    },
    buttonLabel() {
      if (this.contributor.status === 'pending') {
        return 'Update Invite';
      }
      return 'Send Invite';
    },
    statusClass() {
      return `invite-status-${this.contributor.status}`;
    },
    email() {
      if (this.contributor.email) {
        return this.contributor.email;
      }
      return this.contributor.emails[0];
    },
  },
  methods: {
    confirmDelete() {
      this.$refs.contributorDeleteModal.show(this.contributor);
    },
    deleteContributor() {
      if (this.contributor_list_size > 1 && this.contributor.is_primary_poc) {
        this.$swal.fire({
          text: 'It is not possible to delete your Primary Point of Contact. ' +
          'To proceed you need to first select other team member to be your Primary Contact.',
          type: 'error',
          confirmButtonText: 'OK',
        });
        return;
      }

      const dataToRemove = {
        id: this.contributor.id,
        last_poc_update: this.lastPocUpdate,
      };
      this.$reqs.post(`/users/${this.user.id}/poc/delete`, dataToRemove)
        .then((response) => {
          this.$refs.contributorDeleteModal.hide();
          this.$emit('item-deleted', response);
          this.$swal({
            title: 'Success',
            text: response.data.message,
            type: 'success',
          });
        })
        .catch(() => {
          this.$refs.contributorDeleteModal.hide();
          this.$emit('refresh');
        });
    },
    removeContributorRole() {
      this.$reqs.post(`/users/${this.user.id}/poc/remove_role`, {
        id: this.contributor.id,
        last_poc_update: this.lastPocUpdate,
      })
        .then((response) => {
          this.$refs.contributorDeleteModal.hide();
          this.$emit('item-updated', response);
          this.$swal({
            title: 'Success',
            text: response.data.message,
            type: 'success',
          });
        })
        .catch(() => {
          this.$refs.contributorDeleteModal.hide();
        });
    },
    updatePrimaryContact() {
      const dataToSend = {
        poc_id: this.contributor.id,
        last_poc_update: this.lastPocUpdate,
      };
      this.$reqs.post(`/users/${this.user.id}/poc/update_primary_poc`, dataToSend)
        .finally(() => {
          this.$emit('refresh');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/tabs/team_members/ContributorCard.vue